import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from 'src/app/shared/components/alert/alert.module';
import { BadgeModule } from 'src/app/shared/components/badge/badge.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { DatepickerInputModule } from 'src/app/shared/components/datepicker-input/datepicker-input.module';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { EnterOrderModule } from 'src/app/shared/components/enter-order/enter-order.module';
import { InputSearchScannerModule } from 'src/app/shared/components/input-search-scanner/input-search-scanner.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { InventoryLocationsDropdownModule } from 'src/app/shared/components/inventory-locations-dropdown/inventory-locations-dropdown.module';
import { ErrorMessageModule } from 'src/app/shared/error-message/error-message.module';
import { DupTransactionsService } from 'src/app/shared/services/dup-transactions.service';
import { AddNoteModule } from '../../../add-note/add-note.module';
import { DrugsProcessingService } from '../drugs-processing.service';
import { DupTransactionsDialogModule } from '../dup-transactions-dialog/dup-transactions-dialog.module';
import { MultipleDrugsDialogBaseComponent } from './multiple-drugs-dialog-base.component';
import { YesNoToggleModule } from 'src/app/shared/components/yes-no-toggle/yes-no-toggle.module';
import { BackCountNotResolvedTooltipModule } from 'src/app/shared/components/back-count-not-resolved-tooltip/back-count-not-resolved-tooltip.module';



@NgModule({
  declarations: [MultipleDrugsDialogBaseComponent],
  imports: [
    CommonModule,
    InputModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    InputSearchScannerModule,
    ButtonModule,
    ErrorMessageModule,
    EnterOrderModule,
    AddNoteModule,
    DatepickerInputModule,
    AlertModule,
    DupTransactionsDialogModule,
    BadgeModule,
    InventoryLocationsDropdownModule,
    ScrollingModule,
    YesNoToggleModule,
    BackCountNotResolvedTooltipModule
  ],
  providers: [DrugsProcessingService, DupTransactionsService],
  exports: [MultipleDrugsDialogBaseComponent]
})
export class MultipleDrugsDialogBaseModule { }
